var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarbell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC61B"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M512,256c0-5.504-0.195-10.962-0.536-16.381l-71.309-71.309l-2.667,0.369l-12.669-12.669 l-1.141,3.725l-15.972-15.974l-4.456,28.372l-27.257-27.257l-8.056,33.44l-127.883,8.726l-17.958-3.448l-30.053,3.734l-43.725-42.58 l-1.383,31.027l-30.896-30.898l-5.048,52.522l-38.478,4.78l67.41,67.412v92.763l-4.956,4.408l-30.672,10.145l134.503,134.503 C244.486,511.79,250.218,512,256,512C397.384,512,512,397.384,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808183"
    },
    d: "M170.667,352.108h-19.825V150.842c0-4.76-3.86-8.62-8.62-8.62s-8.62,3.86-8.62,8.62v201.266h-19.825 c-7.854,0-14.222,6.368-14.222,14.222s6.368,14.222,14.222,14.222h56.889c7.854,0,14.222-6.368,14.222-14.222 S178.521,352.108,170.667,352.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M398.222,352.108h-19.825V150.842c0-4.76-3.86-8.62-8.62-8.62s-8.62,3.86-8.62,8.62v201.266h-19.825 c-7.854,0-14.222,6.368-14.222,14.222s6.368,14.222,14.222,14.222h56.889c7.854,0,14.222-6.368,14.222-14.222 S406.076,352.108,398.222,352.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424141"
    },
    d: "M437.872,193.508H74.128c-4.76,0-8.62-3.86-8.62-8.62l0,0c0-4.76,3.86-8.62,8.62-8.62h363.744 c4.76,0,8.62,3.86,8.62,8.62l0,0C446.492,189.649,442.632,193.508,437.872,193.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M437.872,176.269H255.426v17.239h182.446c4.76,0,8.62-3.86,8.62-8.62 S442.632,176.269,437.872,176.269z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3D3D"
    },
    d: "M109.468,227.556L109.468,227.556c5.237,0,9.481-4.244,9.481-9.481v-66.37 c0-5.237-4.244-9.481-9.481-9.481l0,0c-5.237,0-9.481,4.244-9.481,9.481v66.37C99.987,223.311,104.231,227.556,109.468,227.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3D3D"
    },
    d: "M76.786,203.852h6.322c3.491,0,6.322-2.831,6.322-6.322v-25.283c0-3.491-2.831-6.322-6.322-6.322 h-6.322c-3.491,0-6.322,2.831-6.322,6.322v25.285C70.465,201.021,73.295,203.852,76.786,203.852z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M93.531,216.781h2.569c4.527,0,8.197-3.67,8.197-8.197v-47.39c0-4.527-3.67-8.197-8.197-8.197h-2.569 c-4.527,0-8.197,3.67-8.197,8.197v47.39C85.333,213.111,89.004,216.781,93.531,216.781z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3D3D"
    },
    d: "M402.532,142.222L402.532,142.222c-5.237,0-9.481,4.244-9.481,9.481v66.37 c0,5.237,4.244,9.481,9.481,9.481l0,0c5.237,0,9.481-4.244,9.481-9.481v-66.37C412.013,146.466,407.769,142.222,402.532,142.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3D3D"
    },
    d: "M435.214,165.926h-6.322c-3.491,0-6.322,2.831-6.322,6.322v25.285c0,3.491,2.831,6.322,6.322,6.322 h6.322c3.491,0,6.322-2.831,6.322-6.322v-25.285C441.535,168.757,438.705,165.926,435.214,165.926z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M418.469,152.997h-2.569c-4.527,0-8.197,3.67-8.197,8.197v47.39c0,4.527,3.67,8.197,8.197,8.197 h2.569c4.527,0,8.197-3.67,8.197-8.197v-47.39C426.667,156.667,422.996,152.997,418.469,152.997z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbell);
export default __webpack_public_path__ + "static/media/barbell.8981bec27d35479bde55fd0dc171913e.svg";
export { ForwardRef as ReactComponent };